import type { IAnswer } from "@/types/types";
import { useState, type FC } from "react";
import { Modal } from "../../../../../../components/modal/Modal";
import AnswerModalHeader from "./AnswerModalHeader";
import AnswerModalContent from "./AnswerModalContent";
import { Pill } from "@/components/pill/Pill";
import { useDate } from "@/hooks/use-date/useDate";
import { useTranslate } from "@/hooks/use-translate/useTranslate";

interface AnswerProps {
  item: IAnswer;
  empty?: boolean;
  idx: number;
}

const Answer: FC<AnswerProps> = ({ item, empty = false, idx }) => {
  const [open, setOpen] = useState(false);
  const translate = useTranslate();

  const { formatDate } = useDate();

  const handleOnOpen = () => {
    if (!empty) {
      setOpen(true);
    }
  };

  const handleOnClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        role="button"
        onClick={handleOnOpen}
        className="flex group w-full text-left border border-ib-gray-borders p-2 rounded-sm bg-transparent cursor-pointer h-32"
      >
        <div className="grid grid-rows-[auto_1fr_auto] gap-2 w-full">
          <p className="text-sm text-ib-gray-main">
            {item.updatedAt && formatDate(item.updatedAt?.toString())}
          </p>
          <h3
            className="text-md text-ib-gray-darkest truncate w-full"
            title={`${item.status} - ${item.comment}`}
          >
            <span className="font-ib-bold text-gray-900">{item.status}</span>
            {item.comment && (
              <>
                <span className="mx-1"> - </span>
                <span className="font-normal">{item.comment}</span>
              </>
            )}
          </h3>
          <div className="flex space-x-4">
            <Pill
              icon={"images"}
              label={item.images?.length}
              className="bg-ib-gray-borders"
              iconClassName="size-3"
            />
            <Pill
              icon={"comments"}
              label={item.comment ? 1 : 0}
              className="bg-ib-gray-borders"
              iconClassName="size-3"
            />
          </div>
        </div>
      </div>
      {open && (
        <Modal>
          <Modal.Header>
            <AnswerModalHeader
              close={handleOnClose}
              closed={true}
              fase={item.phaseId}
              title={`${translate("action")} ${idx}`}
              edition={false}
            />
          </Modal.Header>
          <Modal.Content>
            <AnswerModalContent item={item} edition={false} />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default Answer;
